document.addEventListener('click', (e) => {
  const link = e.target.closest('.page-card__link--async');
  if (link) {
    e.preventDefault();
    const url = link.getAttribute('href');
    const sourceElement = link;
    const pageCard = sourceElement.closest('.page-card');
    let targetContainer = pageCard.nextElementSibling;

    // Check if next sibling exists and has the correct class
    if (targetContainer && targetContainer.classList.contains('page-card-container') && targetContainer.innerHTML.trim() !== '') {
      // Container exists and has content, close it
      closeContainer(pageCard, targetContainer);
    } else {
      // Create the container if it doesn't exist
      if (!targetContainer || !targetContainer.classList.contains('page-card-container')) {
        targetContainer = document.createElement('div');
        targetContainer.classList.add('page-card-container');
        pageCard.parentElement.insertBefore(targetContainer, pageCard.nextSibling);
      }

      const toFetchContentClass = ['page-meta', 'blocks'];
      updateContainer(url, pageCard, targetContainer, toFetchContentClass);
    }

 }
});